import React from "react";
import { Row, Col} from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { achievements } from "../Models";

function Achievements() {
  return (

      <div class="card">
  <div class="card-header" style={{textAlign:"left"}}>
    <h3>Achievements</h3>
  </div>
  <Row style={{ justifyContent: "center", padding: "10px" }}>
    {achievements.map((certificate) => (
      <Col md={4} className="selectedproject-card">
          <Card className="achievement-card-view">
          <a href={certificate.link}><Card.Img variant="top" className='selectedproject_card_img' src={certificate.image} alt="card-img" /></a>
          <Card.Body>
            <div style={{height:270}} className='project-desc'>
            <Card.Title style={{fontWeight:"bold"}}>{certificate.title}</Card.Title>
            
            <div class="d-flex justify-content-around">
              {certificate.stack.map(film => (
                <div class="p-2" style={{backgroundColor:"rgb(220,220,220)", padding:"5px"}}>{film}</div>
              ))}
            </div>

            <Card.Text style={{ textAlign: "justify", paddingTop:"10px" }}>
              {certificate.description}
            </Card.Text>
            </div>
            
          </Card.Body>
        </Card>
      </Col>
        ))}
  </Row>


</div>

  );

}

export default Achievements;